import type { TooltipProps } from 'recharts';
import { Box } from '@ksyos/design-system';

export function MonitoringChartTooltip({
    active,
    payload,
    coordinate,
    position,
}: TooltipProps<number, string>): JSX.Element | null {
    // Only shows tooltip when you are near the dot
    if (
        coordinate?.y !== undefined &&
        position?.y !== undefined &&
        (coordinate.y < position.y || coordinate.y > position.y + 80)
    ) {
        return null;
    }

    if (active && payload && payload.some((item) => item.name === 'value')) {
        const tooltipElement = payload[0].payload.tooltipElement;

        return (
            <Box
                backgroundColor="neutral100"
                border="1px solid"
                borderColor="neutral500"
                borderRadius="md"
                p={3}
            >
                {tooltipElement}
            </Box>
        );
    }

    return null;
}
